import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SagView } from '../../../cases/models';
import { IndexCard } from '../../../../../auth/store/models';
import { ConfirmService } from '../../../../../shared/confirm-dialog/confirm-dialog.service';
import { TimeBudget } from '../../../../../timetrack/store/models';
import { LuxonUtils } from '@shared';

@Component({
    selector: 'app-resourceplan-footer',
    templateUrl: './resourceplan-footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ResourceplanFooterComponent {
    @Input() sag: SagView;
    @Input() user: IndexCard;
    @Input() timeBudgets: TimeBudget[];
    @Output() updateClientCaseV2 = new EventEmitter<{sag: SagView, partialSag: Partial<SagView>}>();

    constructor(
        private confirm: ConfirmService,
    ) { }

    onLock() {
        const locked = !this.sag.locked;
        this.updateClientCaseV2.emit({sag: this.sag, partialSag: {locked}});
    }

    async onCloseCase() {
        if (!this.konklusionGodkendt(this.sag)) {
            const doClose = await this.confirm.question(
                'Der mangler godkendt konklusion på sagen! Er du sikker på, du vil afslutte den?',
                'Ja',
                'Nej'
            );
            if (!doClose) { return; }
        }
        const partialSagView = {
            lukket: true,
            lukketDen: new Date(),
            lukketAf: this.user.brugerId
        };
        this.updateClientCaseV2.emit({sag: this.sag, partialSag: partialSagView});
    }

    private konklusionGodkendt(sag: SagView) {
        return (!sag.reviewpartner && sag.sagKonklusionLAGodkendt)
            || (sag.reviewpartner && sag.sagKonklusionLAGodkendt && sag.sagKonklusionReviewpartnerGodkendt);
    }

    async onReopenCase() {
        const reopenCaseConfirmed = await this.confirm.question(
            'Vil du genåbne denne sag?',
            'Genåbn sag',
            'Annuller'
        );
        if (!reopenCaseConfirmed) { return; }
        const partialSagView = {
            lukket: false,
            lukketDen: null,
            lukketAf: null
        };
        this.updateClientCaseV2.emit({sag: this.sag, partialSag: partialSagView});
    }

    async onInvoiced() {
        if (!this.sag.invoiceAmount) {
            const ignoreNoInvoicesConfirmed = await this.confirm.question(
                'Der blev ikke fundet faktura på sagen! Er du helt sikker på du vil markere sagen som faktureret?',
                'Alt faktureret',
                'Annuller'
            );
            if (!ignoreNoInvoicesConfirmed) { return; }
        }
        if (this.timerBudgetsInFuture()) {
            const ignoreFutureConfirmed = await this.confirm.question(
                'Der er timer planlagt i fremtiden på denne sag! Er du helt sikker på du vil markere sagen som faktureret?',
                'Alt faktureret',
                'Annuller'
            );
            if (!ignoreFutureConfirmed) { return; }
        }
        const partialSagView = {
            faktureret: new Date(),
            faktureretAf: this.user.brugerId
        };
        this.updateClientCaseV2.emit({sag: this.sag, partialSag: partialSagView});
    }

    private timerBudgetsInFuture(): boolean {
        const today = LuxonUtils.now();
        const futureTimerBudgets = this.timeBudgets.find(tb => LuxonUtils.fromObject({year: tb.aar, month: tb.mth, day: 1}) > today);
        return !!futureTimerBudgets;
    }

    async onCancelInvoiced() {
        const cancelInvoicedConfirmed = await this.confirm.question(
            'Vil du genåbne fakturering på denne sag?',
            'Genåbn sag',
            'Annuller'
        );
        if (!cancelInvoicedConfirmed) { return; }
        const partialSagView = {
            faktureret: null,
            faktureretAf: null
        };
        this.updateClientCaseV2.emit({sag: this.sag, partialSag: partialSagView});
    }
}
